export default __webpack_public_path__ + "static/media/avatar_77.12335857.png";